/**
 * Trending Grid
 * Scroll-triggered fade-in with stagger for heading, subheading, and items.
 * No external dependencies. Respects prefers-reduced-motion.
 */

(function () {
  'use strict';

  var SECTION_SELECTOR = '.trending-grid';
  var STAGGER_MS = 45;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealImmediately(section) {
    var animatables = section.querySelectorAll('[data-tg-animate]');
    animatables.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initSection(section) {
    if (!section || section.dataset.trendingGridInit === 'true') return;
    section.dataset.trendingGridInit = 'true';

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      revealImmediately(section);
      return;
    }

    var items = Array.prototype.slice.call(section.querySelectorAll('.trending-grid__item'));
    var headerEls = Array.prototype.slice.call(
      section.querySelectorAll('.trending-grid__heading, .trending-grid__subheading')
    );

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          headerEls.forEach(function (el) {
            el.classList.add('is-visible');
          });

          items.forEach(function (item, index) {
            item.style.setProperty('--tg-delay', index * STAGGER_MS + 'ms');
            item.classList.add('is-visible');
          });

          obs.unobserve(section);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.1,
      }
    );

    observer.observe(section);
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll(document);
  }

  // Shopify Theme Editor integration
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (!section) return;

    section.dataset.trendingGridInit = 'false';
    var visibleEls = section.querySelectorAll('.is-visible');
    visibleEls.forEach(function (el) {
      el.classList.remove('is-visible');
    });

    initSection(section);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (!section) return;
    revealImmediately(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target;
    if (item && item.classList && item.classList.contains('trending-grid__item')) {
      item.classList.add('is-visible');
    }
  });
})();
